import {
  PROGRESSIVE_TOAST_DEFAULT_DURATION_MS,
  showProgressiveHostToast,
} from '@fe-progressive/package-progressive/progressive-toast';
import {useCallback, useEffect} from 'react';
import type {ReactElement} from 'react';
import type {ModalOptions} from './modal.hooks';

export enum ToastType {
  success = 'success',
  warning = 'warning',
  weak = 'weak',
}
export type ToastOptionsType = ToastType | keyof typeof ToastType;
export interface ToastOptions {
  type: ToastOptionsType;
  message?: string;
  tip?: string | ReactElement;
}

export function useToast(
  options: ModalOptions = {backDropClose: true, delayClose: 2000},
) {
  const duration = options.delayClose ?? PROGRESSIVE_TOAST_DEFAULT_DURATION_MS;
  const handleShow = useCallback(
    (showOptions: ToastOptions) => {
      showProgressiveHostToast(showOptions, duration);
    },
    [duration],
  );
  return {renderModal: null, show: handleShow};
}

export function Toast(props: {
  info: {type: string; message: string; tip?: string};
}) {
  const {type, message, tip} = props.info;
  const {renderModal, show} = useToast();
  useEffect(() => {
    show({
      type: type as any,
      message,
      tip,
    });
  }, [type, message, tip, show]);
  return renderModal;
}
